'use client';

import { useRouter } from '@/i18n/routing';
import { Button } from '@/ui';
import { useTranslations } from 'next-intl';

type WebinarCardActionProps = {
  courseId?: number;
  batchId?: number;
  webinarId: number;
};

export const WebinarCardAction = ({
  webinarId,
  courseId,
  batchId,
}: WebinarCardActionProps) => {
  const router = useRouter();
  const t = useTranslations();

  const queryParams = new URLSearchParams();

  if (courseId) {
    queryParams.append('courseId', courseId.toString());
  }

  if (batchId) {
    queryParams.append('batchId', batchId.toString());
  }

  const url = `/webinar/${webinarId}?${queryParams}`;

  const handleEnrollmentUpdate = async () => {
    router.push(url);
  };

  return (
    <Button onClick={handleEnrollmentUpdate} className="text-sm">
      {t('common.see-details')}
    </Button>
  );
};
